const encoder = new TextEncoder();

function bufferToHex(buffer: ArrayBuffer) {
  const bytes = new Uint8Array(buffer);
  let hex = '';
  for (const byte of bytes) {
    hex += byte.toString(16).padStart(2, '0');
  }
  return hex;
}

async function digestToHex(data: BufferSource) {
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  return bufferToHex(hashBuffer);
}

export async function hashDataUrl(dataUrl: string) {
  const encoded = encoder.encode(dataUrl);
  return await digestToHex(encoded);
}

export async function hashBlob(blob: Blob) {
  const buffer = await blob.arrayBuffer();
  // Normalize to a fresh TypedArray so WebCrypto accepts it consistently
  // across jsdom/Node/browser runtimes.
  return await digestToHex(new Uint8Array(buffer));
}

export async function hashBytes(bytes: Uint8Array) {
  // Create a fresh ArrayBuffer-backed Uint8Array. Two reasons:
  //   1. TS 5.7+ strict: `Uint8Array<ArrayBufferLike>` is not assignable to
  //      `BufferSource`. The `new Uint8Array(TypedArray)` overload narrows the
  //      buffer generic to `ArrayBuffer`, producing `Uint8Array<ArrayBuffer>`
  //      which IS a `BufferSource`.
  //   2. jsdom + Node webcrypto at runtime: passing the new TypedArray satisfies
  //      the WebIDL BufferSource conversion (ArrayBufferView check passes).
  return await digestToHex(new Uint8Array(bytes));
}
